module.exports = __webpack_public_path__ + "img/logo-2.37d95766.webp";